<template>
  <div v-html="cancelNoteCopy" />
</template>

<script>
export default {
  name: "CancelInstructions",
  props: {
    cancelNoteType: {
      type: String,
      required: true
    },
    newSubscriptionType: {
      type: String,
      required: true
    }
  },
  computed: {
    cancelNoteCopy() {
      if (this.$te(`cancelNote.${this.cancelNoteType}`)) {
        return this.$t(`cancelNote.${this.cancelNoteType}`, { newSubscriptionCopy: this.newSubscriptionCopy })
      } else {
        return null
      }
    },
    newSubscriptionCopy() {
      if (this.$te(`newSubscriptionCopy.${this.newSubscriptionType}`)) {
        return this.$t(`newSubscriptionCopy.${this.newSubscriptionType}`)
      } else {
        return null
      }
    }
  },
  i18n: {
    messages: {
      en: {
        cancelNote: {
          "itunes":
            "<b>You need to cancel your personal subscription.</b><br /><br />{newSubscriptionCopy}, so you won’t need your personal subscription anymore.<br /><br />Because you bought it through the Apple App Store, you need to cancel it directly from that. <a class='underline' href='https://support.blinkist.com/en/articles/10033387' target='_blank'>Here’s how to do it</a>.",
          "gp-android":
            "<b>You need to cancel your personal subscription.</b><br /><br />{newSubscriptionCopy}, so you won’t need your personal subscription anymore.<br /><br />Because you bought it through the Google Play Store, you need to cancel it directly from that. <a class='underline' href='https://support.blinkist.com/en/articles/10033387' target='_blank'>Here’s how to do it</a>.",
          "recurly":
            "{newSubscriptionCopy}, so you won’t need your personal subscription anymore.<br /><br />Don’t worry, you don't need to do anything—we’ve cancelled it for you to prevent duplicate subscriptions.",
          "stripe":
            "{newSubscriptionCopy}, so you won’t need your personal subscription anymore.<br /><br />Don’t worry, you don't need to do anything—we’ve cancelled it for you to prevent duplicate subscriptions."
        },
        newSubscriptionCopy: {
          mup: "You’re now part of a shared plan",
          team: "You’ve been added to your team plan"
        }
      },
      de: {
        cancelNote: {
          "itunes":
            "<b>Du musst dein eigenes Blinkist Premium-Abo kündigen.</b><br /><br />{newSubscriptionCopy} benötigst du dein eigenes Abo nicht mehr. Leider ist hier keine Erstattung möglich.<br /><br />Hast du das Abo über den Apple App Store abgeschlossen, musst du dies dort direkt kündigen. <a class='underline' href='https://support.blinkist.com/de/articles/10033387' target='_blank'>Erfahre hier, wie das geht.</a>",
          "gp-android":
            "<b>Du musst dein eigenes Blinkist Premium-Abo kündigen.</b><br /><br />{newSubscriptionCopy}, benötigst du dein eigenes Abo nicht mehr. Leider ist hier keine Erstattung möglich.<br /><br />Hast du das Abo über den Google Play Store abgeschlossen, musst du dies dort direkt kündigen. <a class='underline' href='https://support.blinkist.com/de/articles/10033387' target='_blank'>Erfahre hier, wie das geht.</a>",
          "recurly":
            "{newSubscriptionCopy}, benötigst du dein eigenes Abo nicht mehr.<br /><br />Du musst aber nichts tun. Wir übernehmen die Kündigung für dich, damit du kein doppeltes Abo hast.",
          "stripe":
            "{newSubscriptionCopy}, benötigst du dein eigenes Abo nicht mehr.<br /><br />Du musst aber nichts tun. Wir übernehmen die Kündigung für dich, damit du kein doppeltes Abo hast."
        },
        newSubscriptionCopy: {
          mup: "Da du dir nun ein Abo teilst, ",
          team: "Du wurdest zu einem Teamplan hinzugefügt, daher "
        }
      }
    }
  }
}
</script>
